import moment from 'moment';
import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import download from 'src/utils/download';
import { postRequest } from 'src/utils/request';
import { forceString } from 'src/utils/datetime';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import useMessenger from 'src/utils/hooks/useMessenger';
import messages from 'src/pages/ContractsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const archiveContract = async (file: File) => {
  const payload = new FormData();
  payload.append('user_contract[csv_file]', file);

  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.archiveContract,
    payload,
    {
      headers: {
        'content-type': 'multipart/form-data',
        Accept: 'application/vnd.falcon.v2+json',
      },
    },
  );

  return data;
};

export const useArchiveContract = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  const messenger = useMessenger();

  return useMutation({
    mutationFn: archiveContract,
    onSuccess: (data) => {
      const now = forceString(
        moment(),
        moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
      );

      if (data) {
        download(data, `time-trackings-import-failures-${now}.csv`, 'text/csv');
        messenger.warning(formatMessage(messages.contractsArchiveFailedPart2));
        messenger.warning(formatMessage(messages.contractsArchiveFailedPart1));
      } else {
        client.invalidateQueries({
          queryKey: [QUERY_KEYS.CONTRACTS],
        });
        handleSuccess(formatMessage(messages.contractsArchived), 1000);
      }
    },
    onError: handleError,
  });
};
